import { createContext, useContext, useEffect, useId } from 'react';

import { replaceText } from '../../modules/utils/promotionHelper';

export interface LoyaltyWidgetContainerContextValue {
  publishedText?: string;
  publishText: (publisherId: string, text: string | undefined) => void;
}

export const LoyaltyWidgetContainerContext = createContext<LoyaltyWidgetContainerContextValue | undefined>(undefined);

// Child sections resolve their AEM templates then publish the final badge string.
export const useLoyaltyWidgetBadgePublisher = (text: string | undefined): void => {
  const ctx = useContext(LoyaltyWidgetContainerContext);
  const publisherId = useId();

  useEffect(() => {
    if (!ctx) return undefined;
    ctx.publishText(publisherId, text);
    return () => ctx.publishText(publisherId, undefined);
  }, [ctx, publisherId, text]);
};

// Per WEB-203502: defaultLabel covers the empty / zero-available case;
// singular/plural use {0} for the count.
export const buildContainerCountBadgeText = (
  count: number,
  templates?: {
    defaultLabel?: string;
    availableSingularLabel?: string;
    availablePluralLabel?: string;
    zeroAvailableLabel?: string;
  }
): string => {
  const tokens = [String(count)];
  if (count === 0) {
    if (templates?.defaultLabel) return templates.defaultLabel;
    if (templates?.zeroAvailableLabel) return templates.zeroAvailableLabel;
    if (templates?.availablePluralLabel) return replaceText(templates.availablePluralLabel, tokens);
    return '';
  }
  if (count === 1) {
    if (templates?.availableSingularLabel) return replaceText(templates.availableSingularLabel, tokens);
    if (templates?.availablePluralLabel) return replaceText(templates.availablePluralLabel, tokens);
    return '';
  }
  return templates?.availablePluralLabel ? replaceText(templates.availablePluralLabel, tokens) : '';
};
